import { render, staticRenderFns } from "./dialog-create-zdjs.vue?vue&type=template&id=75fbcd84&scoped=true"
import script from "./dialog-create-zdjs.vue?vue&type=script&lang=js"
export * from "./dialog-create-zdjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbcd84",
  null
  
)

export default component.exports